/**
 * Default status column colors
 * 14 colors as per column-types.md specification
 */

export const STATUS_COLORS = {
  green: '#00c875',
  lightGreen: '#9cd326',
  lime: '#cab641',
  yellow: '#ffcb00',
  darkOrange: '#ff642e',
  orange: '#fdab3d',
  red: '#e2445c',
  darkRed: '#bb3354',
  purple: '#a25ddc',
  darkPurple: '#784bd1',
  blue: '#0086c0',
  lightBlue: '#579bfc',
  turquoise: '#66ccff',
  gray: '#c4c4c4',
} as const;

export type StatusColor = (typeof STATUS_COLORS)[keyof typeof STATUS_COLORS];

/**
 * Default status labels for new status columns
 */
export const DEFAULT_STATUS_LABELS = [
  { id: 'not_started', label: 'Not Started', color: STATUS_COLORS.gray },
  { id: 'working', label: 'Working on it', color: STATUS_COLORS.orange },
  { id: 'stuck', label: 'Stuck', color: STATUS_COLORS.red },
  { id: 'done', label: 'Done', color: STATUS_COLORS.green },
] as const;

export type DefaultStatusLabel = (typeof DEFAULT_STATUS_LABELS)[number];
